import React,  {Component} from 'react'; 
import getPerformancesIntervallByTheatre from '../../../functions/getPerformancesIntervallByTheatre'
import getFormatedDate from '../../../functions/getFormatedDate'
import getDateObject from '../../../functions/getDateObj'
import MovieTimesPeriodeDaysItemsDesktop from '../presents/MovieTimesPeriodeDaysItemsDesktop';
import config from '../config.json'


export default class MovieTimesTheatreContainer extends Component {
    constructor (props) {
        super(props) 
    }

    getSortedTheatreObjects(theatreKeys, theatreObjects) {
        const sortedTheatres = theatreKeys.sort(function(a, b) {
            const theatreA = theatreObjects[a]
            const theatreB = theatreObjects[b]
            
            const aName = parseInt(theatreA.theatreID)
            const bName = parseInt(theatreB.theatreID)
            
            return bName > aName ? -1 : bName < aName ? 1 : 0
        })
    
        return sortedTheatres
    }

    render() {
        const { performances, today, activeWeek, translation } = this.props
        const theatres = getPerformancesIntervallByTheatre(performances, activeWeek)

        if(!theatres) {
            return <div>Für diese Woche leider keine Spielzeiten geplant.</div>
        }

        const { dayIntervallObject, dayIntervallKeys, theatreObjects } = theatres
        const todayISO = today.toISOString() 
        const className = 'movie-times-desktop movie-times-days-' + dayIntervallKeys.length
        const sortedTheatreObjectKeys = this.getSortedTheatreObjects(Object.keys(theatreObjects), theatreObjects)

        return (
            <div className={className}>
                <div className="movie-times-grid">
                    {dayIntervallKeys.map((dayKey, index) => {
                        const performanceDate = getFormatedDate(getDateObject(dayKey), translation)
                        const noPerformancesClass = dayIntervallObject[dayKey][0] ? '' : ' no-performances'

                        return <div className={"date text-bold-grey-showtimes-desktop" + noPerformancesClass} key={index}>{performanceDate}</div>
                    })}
                </div>

                <div>
                    {sortedTheatreObjectKeys.map((theatreKey, index) => {
                        const theatre = theatreObjects[theatreKey]
                        const { name, attributes, dayIntervall } = theatre

                        if(dayIntervall.length > 0) {
                            return ''
                        }

                        return (
                            <div className="theatre-sorted-movie-times" key={index}>
                                <div className="theatre-and-attributes-wrapper">
                                    <div className="title-xlarge-theatre theatre">{name}</div>
                                    <div className="attributes">
                                        {attributes && attributes.map((attribute, index) => {
                                            const {name} = attribute
                                            const id = String(attribute.id)
                                            const logoClass = _.contains(config.attributesWithIcons, id) ? 'attribute-logo' : ''
                                            const doNotDisplayTitle = _.contains(config.attributesWithIcons, id) ? 'screen-reader-text' : ''
                                            return (
                                                <span key={index} className={id + ' ' + logoClass} data-attribute={id}><span className={doNotDisplayTitle + ' ' + 'text-medium'}>{name}</span></span>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="movie-times-grid">
                                    {dayIntervallKeys.map((dayKey, index) => {
                                        const performances = dayIntervall[dayKey]
                                        const isToday = todayISO === dayKey 
                                        const additionalClass = isToday ? "is-today" : ""

                                        return (
                                            <div key={index} className={'performances-wrapper ' + additionalClass}>
                                                {performances && <MovieTimesPeriodeDaysItemsDesktop
                                                    performances={performances}
                                                />}
                                            </div>  
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}